import ScCheckbox from "@/src/components/ui-kit/checkbox";
import BlocksAvatar from "@/src/components/ui-kit/blocks-avatar";
import { EventParticipantSnapshot } from "@/src/models/event.model";
import { useTheme } from "@/src/styles/theme-provider";
import { useTranslation } from "react-i18next";
import { Pressable, Text, View } from "react-native";

type ParticipantTableHeaderProps = Readonly<{
  isAuthor: boolean;
  isAllSelected: boolean;
  onToggleAll: () => void;
}>;

export const ParticipantTableHeader = ({
  isAuthor,
  isAllSelected,
  onToggleAll,
}: ParticipantTableHeaderProps) => {
  const { t } = useTranslation();
  const { themeVars } = useTheme();
  return (
    <View className="flex-row items-center py-2 border-b border-ash-3">
      {isAuthor && (
        <View className="w-7 items-center justify-center">
          <ScCheckbox value={isAllSelected} onChange={onToggleAll} />
        </View>
      )}
      <View className="w-9" />
      <Text
        className="flex-1 text-xs font-medium pl-2"
        style={{ color: themeVars["--color-ash-1"] as string }}
      >
        {t("LABEL_COL_NAME")}
      </Text>
      <Text
        className="flex-1 text-xs font-medium"
        style={{ color: themeVars["--color-ash-1"] as string }}
      >
        {t("LABEL_COL_EMAIL")}
      </Text>
      <Text
        className="w-12 text-xs font-medium"
        style={{ color: themeVars["--color-ash-1"] as string }}
      >
        {t("LABEL_COL_GUEST")}
      </Text>
    </View>
  );
};

type ParticipantRowProps = Readonly<{
  participant: EventParticipantSnapshot;
  userId?: string;
  selected: boolean;
  isAuthor: boolean;
  onToggle: () => void;
}>;

export const ParticipantRow = ({
  participant,
  userId,
  selected,
  isAuthor,
  onToggle,
}: ParticipantRowProps) => {
  const { themeVars } = useTheme();
  return (
    <Pressable
      onPress={isAuthor ? onToggle : undefined}
      className="flex-row items-center py-3 active:bg-ash-3 web:hover:bg-ash-3"
    >
      {isAuthor && (
        <View className="w-7 items-center justify-center">
          <ScCheckbox value={selected} onChange={onToggle} />
        </View>
      )}
      <BlocksAvatar
        userId={userId}
        fallbackImageUrl={participant?.profileImageUrl}
        size={36}
        className="bg-ash-3"
      />
      <Text
        className="flex-1 text-sm font-medium pl-2"
        style={{ color: themeVars["--color-onyx-default"] as string }}
        numberOfLines={1}
      >
        {participant?.firstName}
        {""}
        {participant?.lastName}
      </Text>
      <Text
        className="flex-1 text-sm"
        style={{ color: themeVars["--color-ash-1"] as string }}
        numberOfLines={1}
      >
        {participant?.email}
      </Text>
      {/* NOTE: not yet decided to keep guest count */}
      <Text className="w-12 text-sm" style={{ color: themeVars["--color-ash-1"] as string }}>
        {/* {participant?.guestCount ?? 0} */}0
      </Text>
    </Pressable>
  );
};
